const musicList = [
  "./music/la_con_gai_that_tuyet.mp3"
];

function getRandom() {
  return musicList[Math.floor(Math.random() * (musicList.length))];
}

const thingsToExport =  {
  getRandom
}

export default thingsToExport